import { render } from "./OpenFolderIcon.vue?vue&type=template&id=3a74386f"
const script = {}
script.render = render

export default script